import { useMemo } from "react";

import { getValueFromLocalStorage } from "../lib/utils";

import chatFunctions from "../configs/functions.chat";

import appStore from "app/AppStore";

export default function useChatConfig({ config, apiKey }) {
  const chatCompletionOptions = useMemo(() => {
    const { useApiKey, useProxyServer, apiEndpoints, saveChats, chatConfig } =
      config;

    const { include = [] } = chatConfig;

    let url = useProxyServer
      ? apiEndpoints.proxyChatCompletion
      : apiEndpoints.chatCompletion;

    if (appStore.chatSettingsStore.settings.useInputProxy) {
      url = getValueFromLocalStorage("inputProxy");
    }

    const headers = { ...chatConfig.headers };

    if (useApiKey && apiKey) {
      headers["Authorization"] = `Bearer ${apiKey}`;
    }

    const functions =
      include.includes("functions") && chatFunctions.length
        ? chatFunctions
        : undefined;

    const body = {
      ...chatConfig.body,
      functions,
    };

    return {
      body,
      headers,
      url,
      saveChats,
    };
  }, [apiKey, appStore.chatSettingsStore.settings.useInputProxy, config]);

  return {
    chatCompletionOptions,
  };
}
